module.exports = __webpack_public_path__ + "img/historydotcom.81f2bbd0.png";